/* eslint-disable */
import React, { useMemo, useState } from 'react';

import { CTitle, WTitle } from '../../components/Widget';
import { useParams } from 'react-router-dom';
import { useStore } from '../../../../store';
import ExampleImg1 from '../../../../../../assets/2025/topic1600/example-1.png';
import Quiz from '../../components/Quiz';
import section2_7_1 from '../../../../../../assets/2025/topic1600/section2_7_1.png';
import ImgPoint from '../../../../../../assets/2025/arrow.gif';
import section2_7 from '../../../../../../assets/2025/topic1600/section2_7.png';
import section2_7_mobile from '../../../../../../assets/2025/topic1600/section2_7_mobile.png';
import section2_8 from '../../../../../../assets/2025/topic1600/section2_8.png';
import ImgPointBack from '../../../../../../assets/2025/black-arrow-gif.gif';
import section2_81 from '../../../../../../assets/2025/topic1600/section2_81.png';
import section2_9 from '../../../../../../assets/2025/topic1600/section2_9.png';
import { Modal } from 'antd';
import ImgSample from '../../../../../../assets/sample.png';
import ArrowImg from '../../../../../../assets/2025/arrow.gif';
import { useUpdateComponentState } from '../../../hooks';

interface ISection0Props {
  settings: any;
}

const Section2: React.FunctionComponent<ISection0Props> = ({ settings }) => {
  const ID = '3';
  const param = useParams();
  const p_course = param.course || '';
  const p_topic = param['*'] || 'welcome';
  const paragraphsSettings = useMemo(
    () => settings?.paragraphs[2],
    [settings?.paragraphs]
  );
  const updateComponentState = useUpdateComponentState();
  const { quiz } = paragraphsSettings;
  const { updateParagraphState } = useStore();
  const [quizState, setQuizState] = useState(false);
  const quizComplete = () => {
    setQuizState(true);
  };
  const [state, setState] = useState({
    deepfakeFlag: false,
    deepfakeFlag2: false,
  });
  React.useEffect(() => {
    if (quizState) {
      updateComponentState(
        p_course,
        p_topic,
        ID,
        '2025-topic1600-section2-question'
      );
    }
  }, [p_course, p_topic, quizState]);

  React.useEffect(() => {
    if (state.deepfakeFlag) {
      updateComponentState(p_course, p_topic, ID, '2025-topic1600-section2-1');
    }
  }, [p_course, p_topic, state.deepfakeFlag]);

  React.useEffect(() => {
    if (state.deepfakeFlag2) {
      updateComponentState(p_course, p_topic, ID, '2025-topic1600-section2-2');
    }
  }, [p_course, p_topic, state.deepfakeFlag2]);

  const [rdpExampleVisible, setRdpExampleVisible] = useState(false);
  const [vpnExampleVisible, setVpnExampleVisible] = useState(false);
  const [vpnNext, setVpnNext] = useState(false);

  return (
    <div className="topic-section-2">
      <WTitle title={paragraphsSettings?.title}></WTitle>

      <div className="importance-container">
        <CTitle title={paragraphsSettings?.l1}></CTitle>

        <div className="introduce-part">
          <div className="left">
            <p>{paragraphsSettings?.l2}</p>
            <p>{paragraphsSettings?.l3}</p>
            <div className="person1"></div>
          </div>
          <div className="right">
            <p
              dangerouslySetInnerHTML={{
                __html: paragraphsSettings?.l4,
              }}
            />
            <p
              dangerouslySetInnerHTML={{
                __html: paragraphsSettings?.l5,
              }}
            />
            <div className="person2"></div>
          </div>
        </div>

        <div className="benefits">
          <div className="sub-title">{paragraphsSettings?.l6}</div>
          <div className="benefit-item-wrap">
            {paragraphsSettings?.l7?.map(
              (item: { no: string; desc: string }, index: number) => (
                <div key={item.no} className="benefit-item">
                  <div className="item-no">{item.no}</div>
                  <div className="item-desc">{item.desc}</div>
                </div>
              )
            )}
          </div>
        </div>

        <div className="dos-and-donts">
          <div className="dos module">
            <div className="part-title">
              {paragraphsSettings?.l8}
              <span className="right-icon"></span>
            </div>
            {paragraphsSettings?.l9?.map(
              (item: { no: string; desc: string }, index: number) => (
                <div key={item.no} className="item">
                  <div className="item-desc">{item.desc}</div>
                </div>
              )
            )}
          </div>

          <div className="donts module">
            <div className="part-title">
              {paragraphsSettings?.l10}
              <span className="right-icon"></span>
            </div>
            {paragraphsSettings?.l11?.map(
              (
                item: { no: string; desc: string; exampleTip: string },
                index: number
              ) => (
                <div key={item.no} className="item">
                  <div
                    className={`item-desc ${
                      item.exampleTip ? 'example-btn-item' : ''
                    }`}
                  >
                    {item.exampleTip ? (
                      <span
                        className="example-btn"
                        onClick={() => setRdpExampleVisible(true)}
                      >
                        {item.exampleTip}
                      </span>
                    ) : (
                      ''
                    )}
                    <span className="desc-text">{item.desc}</span>
                  </div>
                </div>
              )
            )}
          </div>
          <div className="back-computer"></div>
        </div>

        <Modal
          centered
          open={rdpExampleVisible}
          onCancel={() => setRdpExampleVisible(false)}
          width="75.56rem"
          getContainer={false}
          footer={null}
        >
          <div className="example-wrap">
            <div className="example-img-wrap">
              <img src={ExampleImg1} alt="" />
            </div>
            <div className="flower-icon"></div>
          </div>
        </Modal>
      </div>

      <div className="vpn-container">
        <div className="vpn-wrap">
          <div className="vpn-title-wrap">
            <CTitle title={paragraphsSettings?.l13}></CTitle>
            <span onClick={() => setVpnExampleVisible(true)}>
              {paragraphsSettings?.l14}
            </span>
          </div>
          <div className="vpn-items-wrap">
            {paragraphsSettings?.l15?.map(
              (item: { no: string; desc: string }, index: number) => (
                <div key={item.no} className="item">
                  <div className="item-desc">{item.desc}</div>
                </div>
              )
            )}
            <div className="left-back"></div>
          </div>
        </div>

        <Modal
          centered
          open={vpnExampleVisible}
          onCancel={() => setVpnExampleVisible(false)}
          width="78.19rem"
          getContainer={false}
          footer={null}
        >
          <div className="connect-vpn">
            <div className="left-back"></div>
            <div className="right-back"></div>
            <div className="connect-vpn-title">
              {vpnNext ? paragraphsSettings?.l17 : paragraphsSettings?.l16}
            </div>
            <div
              className="connect-vpn-content"
              onClick={() => !vpnNext && setVpnNext(true)}
            >
              <div
                className={vpnNext ? 'after-img-wrap' : 'before-img-wrap'}
              ></div>
              <div
                className="arrow"
                style={{ display: vpnNext ? 'none' : 'block' }}
              >
                <img src={ArrowImg} alt="" />
              </div>
            </div>
          </div>
        </Modal>
      </div>
      <div className="t1600_custom">
        <div id="2025-topic1600-section2-1" className="example_box_7">
          <CTitle title={paragraphsSettings?.bl1}></CTitle>
          <div className="content_box">
            <img src={section2_7_1} alt="" className="l1" />
            <div className="l2">
              <div
                className="left"
                style={{ display: state.deepfakeFlag ? '' : 'none' }}
              >
                <p className="p1">{paragraphsSettings?.bl31}</p>
                <p className="content-cn">
                  <span className="p2">{paragraphsSettings?.bl32}</span>
                  <span className="p1">{paragraphsSettings?.bl33}</span>
                  <span className="p2">{paragraphsSettings?.bl34}</span>
                  <p className="p1 final-p">{paragraphsSettings?.bl35}</p>
                </p>
                <p className="content-en">
                  <span className="p2">{paragraphsSettings?.bl32}</span>
                  <span className="p1">{paragraphsSettings?.bl33}</span>
                  <span className="p2">{paragraphsSettings?.bl34}</span>
                  <span className="p1">{paragraphsSettings?.bl35}</span>
                  <p className="p1 final-p">{paragraphsSettings?.bl35_1}</p>
                </p>
              </div>
              <div
                className="right"
                onClick={() => setState({ ...state, deepfakeFlag: true })}
              >
                <span className="p1">{paragraphsSettings?.bl2}</span>
                <img
                  src={ImgPoint}
                  alt=""
                  style={{ display: state.deepfakeFlag ? 'none' : '' }}
                  className="arrow_icon"
                />
              </div>
              <img className="for-pc" src={section2_7} alt="" />
              <img className="for-mobile" src={section2_7_mobile} alt="" />
            </div>
          </div>
        </div>
        <div id="2025-topic1600-section2-2" className="example_box_8">
          <div className="padding_box">
            <div className="content_box">
              <div className="img_box">
                <img src={section2_8} alt="" />
              </div>
              <div
                className={`right_box ${
                  state.deepfakeFlag2 && 'animation_box'
                }`}
              >
                <div
                  className="text_item"
                  onClick={() => setState({ ...state, deepfakeFlag2: true })}
                >
                  <img
                    src={ImgPoint}
                    alt=""
                    style={{ display: state.deepfakeFlag2 ? 'none' : '' }}
                    className="arrow_icon"
                  />
                  <div className="inner">
                    <em>01</em>
                    {paragraphsSettings?.bl4}
                  </div>
                </div>
                <div className="text_item">
                  <div className="inner">
                    <em>02</em>
                    {paragraphsSettings?.bl5}
                  </div>
                </div>
                <div className="text_item">
                  <div className="inner">
                    <em>03</em>
                    {paragraphsSettings?.bl6}
                  </div>
                </div>
                <div className="text_item">
                  <div className="inner">
                    <em>04</em>
                    {paragraphsSettings?.bl7}
                  </div>
                </div>
                <div className="text_item">
                  <div className="inner">
                    <em>05</em>
                    {paragraphsSettings?.bl8}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="example_box_9">
          <div className="padding_box">
            <div className="c-title-box">
              <CTitle title={paragraphsSettings?.bl9}></CTitle>
            </div>
            <div className="content_box">
              <div className="img_box">
                <img src={section2_81} alt="" />
                {/*<img*/}
                {/*  src={ImgPointBack}*/}
                {/*  alt=""*/}
                {/*  style={{display: state.deepfakeFlag2 ? 'none' : ''}}*/}
                {/*  className="arrow_icon"*/}
                {/*/>*/}
              </div>
              <div className={`right_box`}>
                <div className="text_item">
                  <div className="inner">
                    <em>{paragraphsSettings?.bl10}</em>
                    {paragraphsSettings?.bl12}
                  </div>
                </div>
                <div className="text_item">
                  <div className="inner">
                    <em>{paragraphsSettings?.bl13}</em>
                    {paragraphsSettings?.bl14}
                  </div>
                </div>
                <div className="text_item">
                  <div className="inner">
                    <em>{paragraphsSettings?.bl15}</em>
                    {paragraphsSettings?.bl16}
                  </div>
                </div>
                <div className="text_item">
                  <div className="inner">
                    <em>{paragraphsSettings?.bl17}</em>
                    {paragraphsSettings?.bl18}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="example_box_10">
          <div className="padding_box">
            <CTitle title={paragraphsSettings?.bl19}></CTitle>
            <div className="content_box">
              <div className="img_box">
                <img src={section2_9} alt="" />
              </div>
              <div className={`right_box`}>
                <div className="text_item">
                  <div className="inner">
                    <em>01</em>
                    {paragraphsSettings?.bl20}
                  </div>
                </div>
                <div className="text_item">
                  <div className="inner">
                    <em>02</em>
                    {paragraphsSettings?.bl21}
                  </div>
                </div>
                <div className="text_item">
                  <div className="inner">
                    <em>03</em>
                    {paragraphsSettings?.bl22}
                  </div>
                </div>
                <div className="text_item">
                  <div className="inner">
                    <em>04</em>
                    {paragraphsSettings?.bl23}
                  </div>
                </div>
                <div className="text_item">
                  <div className="inner">
                    <em>05</em>
                    {paragraphsSettings?.bl24}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="2025-topic1600-section2-question" className="topic-quiz">
        <Quiz
          title={paragraphsSettings?.questionTitle}
          description={quiz?.description}
          question={quiz?.question}
          options={quiz?.options}
          onCompleted={quizComplete}
        />
      </div>
    </div>
  );
};

export default React.memo(Section2);
